module.exports = __webpack_public_path__ + "assets/img/heading.4e360c75.png";